import { Stack } from '@/components/layout';
import { SvgIcon, Text } from '@/components/ui';
import { hitSlop } from '@/constants';
import { STRINGS } from '@/constants/strings';
import { useScaling, useUnAuthStackNavigation } from '@/hooks';
import { colors } from '@/theme/colors';
import { useCallback } from 'react';
import { Pressable, StyleSheet } from 'react-native';

export const BackPressable = () => {
  const { scale } = useScaling();
  const navigation = useUnAuthStackNavigation();
  const handleBack = useCallback(() => {
    navigation.goBack();
  }, [navigation]);
  return (
    <Pressable onPress={handleBack} hitSlop={hitSlop}>
      <Stack direction="row" align="center" gap={scale(4)}>
        <Text variant="Font Inter/Subtitle/Bold 12px" style={styles.backText}>
          {STRINGS.auth.enterPassword.buttonBack}
        </Text>
        <SvgIcon name="IcBack" size={14} color={'#EA7D24'} />
      </Stack>
    </Pressable>
  );
};

const styles = StyleSheet.create({
  backText: {
    color: colors.Blue,
    textAlign: 'center',
  },
});
